import React from 'react';
import Typography from '@material-ui/core/Typography';
import { experimentalStyled } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import StepLabel from '@material-ui/core/StepLabel';
import { BackButton } from '../Navigation/BackButton/BackButton.js';
var Main = experimentalStyled(Grid)(function (_ref) {
  var theme = _ref.theme;
  return "\n  height: 100vh;\n  background-color: ".concat(theme.palette.secondary.light, " ;\n");
});

var Panel = function Panel(_ref2) {
  var handleBack = _ref2.handleBack,
      children = _ref2.children,
      StepText = _ref2.StepText;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    direction: "row",
    justifyContent: "space-between",
    alignItems: "flex-start"
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, handleBack && /*#__PURE__*/React.createElement(BackButton, {
    handleBack: handleBack
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(StepLabel, null, /*#__PURE__*/React.createElement(Typography, {
    align: "right"
  }, StepText)))), /*#__PURE__*/React.createElement(Main, {
    container: true,
    direction: "column",
    justifyContent: "center",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Box, {
    sx: {
      width: '75%'
    }
  }, children)));
};

export { Panel };